import React, { useState } from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import GlobalStyle from "./global-style"
import Header from "./header"
import Footer from "./footer"

const Layout = ({
  children,
  openMenu = false,
  onCollapse,
  demandAcademy = false,
  forceHeaderStuck = false,
}) => {
  const [collapse, setCollapse] = useState(openMenu)
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  function hideContent(hide) {
    setCollapse(hide)
    onCollapse && onCollapse(hide)
  }

  return (
    <>
      <GlobalStyle />
      <Helmet
        bodyAttributes={{
          class: "bg-black",
        }}
      >
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
        <meta
          name="google-site-verification"
          content="TCQPzqTB9x6DRYqwXavKgu1-6geTOShR5KF2oSQJgow"
        />
        <link rel="dns-prefetch" href="//js.hs-scripts.com" />
      </Helmet>
      <Header
        siteTitle={data.site.siteMetadata.title}
        collapse={hideContent}
        open={openMenu}
        demandAcademy={demandAcademy}
        forceStuck={forceHeaderStuck}
      />
      {!collapse && (
        <>
          {children}
          <Footer />
        </>
      )}
    </>
  )
}

export default Layout
